module.exports = __webpack_public_path__ + "img/_ABS9738.cb62357c.jpg";